import { render, staticRenderFns } from "./KanbanDaySummary.vue?vue&type=template&id=b80ed5aa&scoped=true"
import script from "./KanbanDaySummary.vue?vue&type=script&lang=js"
export * from "./KanbanDaySummary.vue?vue&type=script&lang=js"
import style0 from "./KanbanDaySummary.vue?vue&type=style&index=0&id=b80ed5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ed5aa",
  null
  
)

export default component.exports